
import { AlertCircle, Crown } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { hasReachedFreeLimit } from "@/utils/diary";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getLocalEntries } from "@/utils/diary/localStorage";

// The component must be used within a Router context
const PremiumAlert = () => {
  const navigate = useNavigate();
  const [freeEntries, setFreeEntries] = useState(0);
  const [reachedLimit, setReachedLimit] = useState(false);
  
  useEffect(() => {
    // Count the free entries from localStorage for immediate display
    setFreeEntries(getLocalEntries().filter(entry => !entry.isPremium).length);
    
    // Check if the limit has been reached (async)
    hasReachedFreeLimit().then(limit => {
      setReachedLimit(limit);
    });
  }, []);
  
  if (!reachedLimit) {
    return (
      <Alert className="mb-6">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Free Plan</AlertTitle>
        <AlertDescription className="flex justify-between items-center">
          <span>You're using {freeEntries} of 30 free entries</span>
          <Button variant="outline" size="sm" onClick={() => navigate("/premium")}>
            Upgrade
          </Button>
        </AlertDescription>
      </Alert>
    );
  }
  
  return (
    <Alert className="mb-6 border-amber-200 bg-amber-50">
      <Crown className="h-4 w-4 text-amber-800" />
      <AlertTitle className="text-amber-800">Premium Required</AlertTitle>
      <AlertDescription className="flex justify-between items-center text-amber-800">
        <span>You've reached the limit of 30 free entries</span>
        <Button 
          className="bg-amber-500 hover:bg-amber-600 text-white" 
          size="sm" 
          onClick={() => navigate("/premium")}
        >
          Upgrade Now
        </Button>
      </AlertDescription>
    </Alert>
  );
};

export default PremiumAlert;
